import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useThemeProvider } from "../../providers/ThemeProvider";

const SimpleDialogComponent = ({
  open,
  title,
  child,
  scroll = "paper",
  maxWidth = "sm",
  fullWidth = true,
  onClose,
  onSubmitTitle = null,
  onSubmit = null,
}) => {
  const descriptionElementRef = useRef(null);
  const { t, i18n } = useTranslation();
  const theme = useThemeProvider();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        className={theme.styles.classes.dialogTitle}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        >
          {child}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("close")}</Button>
        {onSubmitTitle !== null && (
          <Button onClick={onSubmit}>{onSubmitTitle}</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SimpleDialogComponent;
